import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Link } from 'react-router-dom';
import DomoticNavbar from '../Components/Navbar';
import "../Components/navbar.css";
import "./solar-systems.css";
import solar1 from "./img-domotic/solarsystem1.png"
import solar2 from "./img-domotic/solarsystem2.png"
import solar3 from "./img-domotic/solarsystem1.png"

import sunpower from "./img-domotic/solarsystem1.png"
import lg from "./img-domotic/solarsystem1.png"
import solaredge from "./img-domotic/solarsystem1.png"
import enphase from "./img-domotic/solarsystem1.png"

const SolarEnergy = () => {
  const [showMenu, setShowMenu] = useState(false);

  // Datos específicos para Energía Solar
  const imagenesGaleria = [
    { src: solar1, alt: "Instalación de paneles solares", caption: "Sistemas fotovoltaicos residenciales y comerciales" },
    { src: solar2, alt: "Instalación profesional", caption: "Técnicos certificados en implementación" },
  ];

  const servicios = [
    {
      icon: "☀️",
      titulo: "Paneles Solares",
      descripcion: "Instalación de sistemas fotovoltaicos con tecnología de última generación.",
      features: ["Monocristalinos/Policristalinos", "Garantías de 25+ años", "Eficiencia >22%"]
    },
    {
      icon: "🔋",
      titulo: "Almacenamiento",
      descripcion: "Sistemas de baterías para maximizar el autoconsumo y respaldo energético.",
      features: ["Baterías de litio", "Gestión inteligente", "Integración con red"]
    },
    {
      icon: "📱",
      titulo: "Monitoreo Inteligente",
      descripcion: "Plataformas para seguimiento en tiempo real del rendimiento del sistema.",
      features: ["App móvil", "Alertas de rendimiento", "Reportes de ahorro"]
    },
    {
      icon: "🏭",
      titulo: "Soluciones Industriales",
      descripcion: "Sistemas a gran escala con inversores centrales para alta demanda.",
      features: ["Plantas solares", "Huertos fotovoltaicos", "PPA (Power Purchase Agreements)"]
    }
  ];

  const tiposSoluciones = [
    {
      categoria: "Residencial",
      items: [
        "On-grid (conectado a red)",
        "Off-grid (autónomo)",
        "Sistemas híbridos",
        "Bombeo solar"
      ]
    },
    {
      categoria: "Comercial",
      items: [
        "Sistemas para retail",
        "Cubiertas solares",
        "Estacionamientos solares",
        "Naves industriales"
      ]
    },
    {
      categoria: "Componentes",
      items: [
        "Microinversores",
        "Optimizadores de potencia",
        "Estructuras de montaje",
        "Protecciones eléctricas"
      ]
    }
  ];

  const marcas = [
    { nombre: "SunPower", logo: sunpower },
    { nombre: "LG Solar", logo: lg },
    { nombre: "SolarEdge", logo: solaredge },
    { nombre: "Enphase", logo: enphase },
    { nombre: "Fronius", logo: "/marcas/fronius.png" },
    { nombre: "Huawei Solar", logo: "/marcas/huawei-solar.png" }
  ];

  // Efecto de scroll reveal
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.solar-scroll-reveal').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="solar-container">
      <DomoticNavbar/>
      
      {/* Hero Section */}
      <section className="solar-hero">
        <div className="solar-hero-content">
          <h1 className="solar-hero-title">Sistemas de Energía Solar</h1>
          <p className="solar-hero-subtitle">
            Soluciones sostenibles para generación y almacenamiento de energía
          </p>
        </div>
      </section>

      {/* Galería de Imágenes */}
      <section className="solar-gallery solar-scroll-reveal">
        {imagenesGaleria.map((img, index) => (
          <div key={index} className="solar-gallery-item">
            <img 
              src={img.src} 
              alt={img.alt}
              className="solar-gallery-img"
            />
            <div className="solar-gallery-caption">
              <p>{img.caption}</p>
            </div>
          </div>
        ))}
      </section>

      {/* Servicios Destacados */}
      <section className="solar-services">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16 solar-scroll-reveal">
            <div className="w-24 h-1 bg-yellow-500 mx-auto mt-4"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {servicios.map((servicio, index) => (
              <div 
                key={index} 
                className={`solar-service-card solar-scroll-reveal delay-${index + 1}`}
              >
                <div className="solar-service-icon">{servicio.icon}</div>
                <h3 className="solar-service-title">{servicio.titulo}</h3>
                <p className="text-gray-300 mb-4">{servicio.descripcion}</p>
                <ul>
                  {servicio.features.map((feature, i) => (
                    <li key={i} className="solar-service-feature text-gray-300">
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default SolarEnergy;